import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../data.service';

@Component({
  selector: 'app-formularios',
  templateUrl: './formularios.component.html',
  styleUrls: ['./formularios.component.css']
})
export class FormulariosComponent implements OnInit {

  /** Respuesta cruda del endpoint */
  estrategias: any[] = [];

  /**
   * Estructura que usa la plantilla:
   * {
   *   [NombreEstrategia]: {
   *     [NombreProyecto]: Modulo[]
   *   }
   * }
   */
  agrupados: Record<string, Record<string, any[]>> = {};

  constructor(private data: DataService,
              private router: Router) { }

  ngOnInit(): void {
    // 👉  Sustituye ObtenerFormularios por el nuevo endpoint
    this.data.ObtenerEstrategias().subscribe(resp => {

      console.log("============================Respuesta de ObtenerEstrategias:============================");
      console.log(resp);
      this.estrategias = resp;
      this.agrupar();
    });
  }

  /** Transforma la respuesta nueva a la estructura antigua */
  private agrupar(): void {
    this.agrupados = {};

    for (const est of this.estrategias) {
      const nomEstr = est.NombreEstrategia;

      if (!this.agrupados[nomEstr]) {
        this.agrupados[nomEstr] = {};
      }

      for (const proy of est.Proyectos) {
        const nomProy = proy.NombreProyecto;

        if (!this.agrupados[nomEstr][nomProy]) {
          this.agrupados[nomEstr][nomProy] = [];
        }

        // Añadimos cada módulo con datos extra del proyecto
        for (const mod of proy.Modulos) {
          this.agrupados[nomEstr][nomProy].push({
            ...mod,
            Proyecto    : nomProy,                       // para abrirProyecto()
            Descripcion : proy.DescripcionProyecto,      // para mostrar en la cabecera
            PBI         : proy.PBI ?? null               // puede venir vacío
          });
        }
      }
    }
  }

  /** Navega al detalle del formulario */
  navigateToFormulario(id: string): void {
    this.router.navigate(['/formulario', id]);
  }

  /** Navega al Excel del proyecto (usa el primero de la lista) */
  abrirProyecto(kv: { key: string; value: any[] }): void {
    const primero = kv.value[0];
    this.router.navigate(['/proyecto', primero.Proyecto]);
  }
}
